import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

/**
 * A Link that redirects to /register when user is not authenticated.
 * When authenticated, navigates to the original `to` prop.
 */
const AuthLink = ({ to, children, ...props }) => {
  const auth = useContext(AuthContext);
  const isAuthenticated = auth?.isAuthenticated;
  
  return (
    <Link to={isAuthenticated ? to : '/register'} {...props}>
      {children}
    </Link>
  );
};

export default AuthLink;
